import { formatDate } from '@/features/shared/labels';
import { currentLocale } from '@/lib/i18n';

export function formatDateTime(iso: string): string {
  return formatDate(iso, currentLocale(), true) ?? '';
}

export function formatDay(iso: string): string {
  return formatDate(iso, currentLocale()) ?? '';
}

export function placeSubtitle(place: {
  cuisines: string[];
  street: string | null;
  city: string | null;
}): string {
  return [place.cuisines.slice(0, 3).join(', '), place.street, place.city]
    .filter(Boolean)
    .join(' · ');
}
